<div class="root-footer">
  <!-- 
  TODO: Might be needed for public facing find data page. TBD.
  <div class="comreg-info">
    <div class="comreg-info__contact">
      <div class="comreg-info__column">
        <div class="comreg-info__address">
          <p>
            Commission for Communications Regulation,<br />
            One Dockland Central, Guild Street, <br />
            Dublin, D01 E4X0
          </p>
          <a class="comreg-info__link outlined" href="https://www.comreg.ie/contact/#map-anchor" target="_blank" rel="noopener">View on Map</a>
        </div>
      </div>
      <div class="comreg-info__column">
        <div class="comreg-info__row">
          <div class="comreg-info__label">Consumer:</div>
          <div class="comreg-info__details">
            <p>
              <a class="comreg-info__tel" href="tel:018049668">018049668</a><br />
              <a class="comreg-info__link outlined" href="mailto:consumerline@comreg.ie">consumerline&#64;comreg.ie</a>
            </p>
          </div>
        </div>
        <div class="comreg-info__row">
          <div class="comreg-info__label">Industry:</div>
          <div class="comreg-info__details">
            <p>
              <a class="comreg-info__tel" href="tel:018049600">018049600</a><br />
              <a class="comreg-info__link outlined" href="mailto:industry@comreg.ie">industry&#64;comreg.ie</a>
            </p>
          </div>
        </div>
      </div>
    </div> 
  </div>-->

  <div class="root-footer__content" [ngClass]="{ 'root-footer__content--phone': isPhoneScreen }">
    <div class="root-footer__copyright">
      Commission for Communications Regulation -
      <a href="https://www.comreg.ie">ComReg.ie</a> © 2025 -
      <a href="https://www.comreg.ie/privacy/" target="_blank" rel="noopener">Privacy Statement</a> -
      <a href="/disclaimer" target="_blank" rel="noopener"> Disclaimer</a>
    </div>
  </div>
</div>
